import { rate, Rating, TrueSkill } from "ts-trueskill";

// Set the draw probability to 0
const env = new TrueSkill(undefined, undefined, undefined, undefined, 0);

export default function calculateNewRatings(
  attackerRating: number,
  defenderRating: number,
  attackerWon: boolean
) {
  const attacker = new Rating(attackerRating);
  const defender = new Rating(defenderRating);
  let newAttackerRating, newDefenderRating;
  attackerWon
    ? ([newAttackerRating, newDefenderRating] = rate([[attacker], [defender]]))
    : ([newDefenderRating, newAttackerRating] = rate([[defender], [attacker]]));
  return [
    parseInt(newAttackerRating[0].mu.toFixed(0)),
    parseInt(newDefenderRating[0].mu.toFixed(0)),
  ];
}
